import { ADD_TO_PRESCRIPTION, DURATION, EYE, FREQUENCY, RETAIN_AFTER_EXAMINATION } from 'store/medicalHistory';

export const headerFields = [
  { id: EYE, content: 'Auge', width: '20%' },
  { id: FREQUENCY, content: 'Dosis', width: '28%' },
  { id: DURATION, content: 'Zeitraum', width: '28%' },
  { id: ADD_TO_PRESCRIPTION, content: 'Einmalig', width: '10%' },
  { id: RETAIN_AFTER_EXAMINATION, content: 'Wiederkehrend', width: '14%' },
].map((item) => ({ ...item, withoutSort: true }));
